/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMusicCheck = createReactComponent("music-check", "IconMusicCheck", [
  ["path", { d: "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", key: "svg-0" }],
  ["path", { d: "M9 17v-13h10v9.5", key: "svg-1" }],
  ["path", { d: "M9 8h10", key: "svg-2" }],
  ["path", { d: "M15 19l2 2l4 -4", key: "svg-3" }]
]);

export { IconMusicCheck as default };
//# sourceMappingURL=IconMusicCheck.js.map
